import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import { BreadCrumb, PageLayouts, SettingsFormViewPanel, useMountedState } from "components/common";
import { useParams } from "react-router-dom";
import { useSupplierService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { SupplierSettingsFormContainer } from ".";

const SupplierSettings: React.FC = (props) => {
  const supplierService = useSupplierService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");
  const { getMounted } = useMountedState();

  const [supplier, setSupplier] = React.useState<WintSuperkollAPIModel.IncomingInvoiceSupplierInfo>();

  const getSupplier = () => {
    supplierService
      .getSupplier(id)
      .then((result) => {
        if (getMounted()) {
          setSupplier(result);
        }
      })
      .catch((e) => {
        console.warn("error");
      });
  };

  React.useEffect(() => {
    getSupplier();
  }, [id]);

  return (
    <PageLayouts.EntityFullScreen
      entityKey={`supplier-settings`}
      id={id ?? 0}
      navigation={
        <BreadCrumb
          prevItems={[
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.Supplier),
              href: UrlHelper.formatPath("/Reports/Suppliers"),
            },
            { text: supplier?.name ?? "", href: UrlHelper.formatPath(`/Supplier/${id}/`) },
          ]}
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Settings)}
          showHome
        />
      }
    >
      {supplier ? (
        <PageLayouts.SettingsLayout
          title={supplier.name ?? ""}
          navItems={[
            {
              navKey: "supplierSettings",
              title: TranslationKeys.Common.Settings,
              content: (
                <SettingsFormViewPanel successMessage={TranslationKeys.Supplier.SupplierUpdated}>
                  <SupplierSettingsFormContainer supplier={supplier} />
                </SettingsFormViewPanel>
              ),
            },
          ]}
        ></PageLayouts.SettingsLayout>
      ) : (
        <></>
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default SupplierSettings;
